import { Flag, WarningCircle } from "@phosphor-icons/react"

import { Tooltip } from "~/components/reusable/Tooltip"
import { formatName } from "~/utils/namingUtils"

export const getLifecyclePhaseWarningIcon = (lifecycleStatus: string | null | undefined) => {
  if (lifecycleStatus === "phasingOut") {
    return (
      <Tooltip
        title="Phasing out"
        description="No forecasts or suggested purchases. Do not purchase."
      >
        <WarningCircle weight="fill" className="h-4 w-4 text-badge-orange-fg-text" />
      </Tooltip>
    )
  }
  if (lifecycleStatus === "phasedOut") {
    return (
      <Tooltip title="Phased out" description="No demand or suggested purchases. Do not purchase.">
        <WarningCircle weight="fill" className="h-4 w-4 text-badge-red-fg-text" />
      </Tooltip>
    )
  }
  return null
}

export const getStatusFlag = (
  lifecycleStatus: string | undefined,
  forecastQuantity: number | null,
  withTooltip: boolean = true,
  sellDownEnabled: boolean = false,
) => {
  if (lifecycleStatus === "phasingOut") {
    if (withTooltip) {
      return (
        <Tooltip
          title="Phasing out"
          description={
            sellDownEnabled
              ? "Forecast shown as sell-down to stockout. No suggested purchases.\nWill stop when changed to 'Phased out'."
              : "No forecasts or suggested purchases."
          }
        >
          <Flag className="h-5 w-5 text-orange-400" />
        </Tooltip>
      )
    }
    return <Flag className="h-5 w-5 text-orange-400" />
  } else if (lifecycleStatus === "phasedOut") {
    if (withTooltip) {
      return (
        <Tooltip
          title="Phased out"
          description={`No demand or suggested purchases.\nStock and ${formatName("sale", true)} data remain visible.`}
        >
          <Flag className="h-5 w-5 text-red-400" />
        </Tooltip>
      )
    }
    return <Flag className="h-5 w-5 text-red-400" />
  } else if (forecastQuantity === null) {
    if (withTooltip) {
      return (
        <Tooltip title="Insufficient data to provide an expected demand.">
          <Flag className="h-5 w-5 text-fg-muted" />
        </Tooltip>
      )
    }
    return <Flag className="h-5 w-5 text-fg-muted" />
  }
}
